import { useCallback, useRef } from 'react';
import { WIX_HEADER_HEIGHT } from '@wix/core-domain-search';
const DOMAINS_HEADING_SCROLL_PADDING_PX = 8;
const WIX_HEADER_HEIGHT_PX = parseInt(WIX_HEADER_HEIGHT, 10);
const scrollElementBelowStickyHeader = function (target, stickyHeader, stickyHeaderOffset) {
  if (stickyHeaderOffset === void 0) {
    stickyHeaderOffset = 0;
  }
  const headerHeight = (stickyHeader == null ? void 0 : stickyHeader.getBoundingClientRect().height) ?? 0;
  const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - stickyHeaderOffset - DOMAINS_HEADING_SCROLL_PADDING_PX;
  window.scrollTo({
    top: Math.max(0, top),
    behavior: 'smooth'
  });
};
const runAfterNextPaint = callback => {
  requestAnimationFrame(() => {
    requestAnimationFrame(callback);
  });
};
export const useScrollToDomainsHeading = () => {
  const stickyHeaderRef = useRef(null);
  const domainsHeadingRef = useRef(null);
  const scrollToDomainsHeading = useCallback(() => {
    runAfterNextPaint(() => {
      const domainsHeading = domainsHeadingRef.current;
      if (!domainsHeading) {
        return;
      }
      scrollElementBelowStickyHeader(domainsHeading, stickyHeaderRef.current, WIX_HEADER_HEIGHT_PX);
    });
  }, []);
  return {
    stickyHeaderRef,
    domainsHeadingRef,
    scrollToDomainsHeading
  };
};
//# sourceMappingURL=useScrollToDomainsHeading.js.map